
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/[categorySlug]/[articleSlug]",
      function () {
        return require("private-next-pages/help/[categorySlug]/[articleSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/[categorySlug]/[articleSlug]"])
      });
    }
  